import * as allergens from 'app/mocks/data/catalogue/products/allergens/list'
import * as categories from 'app/mocks/data/catalogue/products/categories/list'
import * as subcategories from 'app/mocks/data/catalogue/products/subcategories/list'
import * as suppliers from 'app/mocks/data/catalogue/suppliers/list'
import * as managers from 'app/mocks/data/park/managers/list'

import { NutriScore, Product } from 'app/types/catalogue/product'

export const product1: Product = {
    id: 1,
    name: 'Ananas Dole',
    client: managers.manager1,
    supplier: suppliers.supplier1,
    category: categories.category1,
    subcategory: subcategories.subcategory1,
    price: 7,
    is_price_weight: true,
    allergens: [],
    purchase_price: 5,
    valid_number_of_days: 20,
    tva: 10,
    description:
        'Des morceaux de pêche délicieusement fondants et naturellement sucrés, dans une coupelle avec pic inclus : idéal en dessert ou en snack où vous voulez (au bureau, au parc, après le sport, …). Sans sucre ajouté, c’est un aliment naturel et sain. C’est 1 portion de fruit sur les 5 recommandées chaque jour !',
    ean: '789935795125848',
    client_serial: 'D1A203B659',
    photo: 'https://apis-dev.e-thik.com/media/products/dole.webp.200x200_q75.jpg',
    weight: 200,
    disabled: false,
    luncheon_vouchers: false,
    energy_kj: 251,
    energy_kcal: 60,
    carbs: 14,
    sugars: 13,
    fibers: 1,
    proteins: 1.4,
    salt: 1.4,
    needs_cooking: false,
    mass_measure_1: 214,
    mass_measure_2: 216,
    mass_measure_3: 218,
    mass_measure_4: 900,
    mass_measure_5: 219,
    age_limit: false,
}

export const product2: Product = {
    id: 2,
    name: 'AvocadoTruite (8 pcs)',
    client: managers.manager1,
    supplier: suppliers.supplier1,
    category: categories.category2,
    subcategory: subcategories.subcategory2,
    price: 6.45,
    is_price_weight: true,
    allergens: [allergens.allergen1],
    purchase_price: 1,
    valid_number_of_days: 2,
    tva: 5.5,
    description:
        '8 pièces California Makis à base de Riz assaisonné, Truite fraiche Française, Avocat, Fromage frais, Oignons frits',
    ean: '3770033735008',
    client_serial: 'ADZ52654S3',
    photo: 'https://apis-dev.e-thik.com/media/products/e-thik_dev_17073234358966522.jpeg.200x200_q75.jpg',
    weight: 168,
    disabled: false,
    luncheon_vouchers: false,
    energy_kj: 2_035.74,
    energy_kcal: 320.18,
    saturated_fats: 4.25,
    carbs: 38.25,
    sugars: 9.12,
    fibers: 2.54,
    proteins: 12.41,
    salt: 2.33,
    needs_cooking: false,
    age_limit: false,
}

export const product3: Product = {
    id: 3,
    name: 'Badoit',
    client: managers.manager1,
    supplier: suppliers.supplier2,
    category: categories.category3,
    price: 2.6,
    is_price_weight: false,
    allergens: [],
    purchase_price: 1.5,
    valid_number_of_days: 90,
    tva: 10,
    description: 'TARATARA',
    ean: '15473890',
    client_serial: 'PDQ8569F67',
    photo: 'https://apis-dev.e-thik.com/media/products/Badoit1.png.200x200_q75.png',
    weight: 0,
    volume: 10,
    disabled: false,
    luncheon_vouchers: false,
    needs_cooking: false,
    mass_measure_1: 555,
    mass_measure_2: 555,
    mass_measure_3: 555,
    mass_measure_4: 555,
    mass_measure_5: 555,
    nutriscore: NutriScore.enum.A,
    age_limit: false,
}

export const product4: Product = {
    id: 4,
    name: 'Basilic Poulet (8 pcs)',
    client: managers.manager1,
    supplier: suppliers.supplier2,
    category: categories.category25,
    subcategory: subcategories.subcategory2,
    price: 5.95,
    is_price_weight: false,
    allergens: [allergens.allergen1],
    purchase_price: 1,
    valid_number_of_days: 2,
    tva: 5.5,
    description:
        '8 pièces California Makis à base de Riz assaisonné, Algue Nori Grade A, Poulet (halal) Mariné (marinade maison), Avocat, Pomme, Mayonnaise Vegan, Basilic, Oignons frits',
    ean: '3770033735084',
    client_serial: 'ALK299232J',
    photo: 'https://apis-dev.e-thik.com/media/products/test_17073826068324177.jpeg.200x200_q75.jpg',
    weight: 185,
    disabled: false,
    luncheon_vouchers: false,
    energy_kj: 2_445.7,
    energy_kcal: 363.5,
    saturated_fats: 3.5,
    carbs: 40,
    sugars: 9.2,
    fibers: 2.4,
    proteins: 15.4,
    salt: 1.9,
    needs_cooking: false,
    age_limit: false,
}

export const product5: Product = {
    id: 5,
    name: 'Beignets d’aubergines et feta',
    client: managers.manager1,
    supplier: suppliers.supplier2,
    category: categories.category26,
    price: 6,
    is_price_weight: true,
    allergens: [],
    purchase_price: 1,
    valid_number_of_days: 30,
    tva: 5.5,
    description: '',
    ean: '3760198780104',
    client_serial: 'LDZ8323PDA',
    photo: 'https://apis-dev.e-thik.com/media/products/16_aubergine_.jpg.200x200_q75.jpg',
    weight: 160,
    disabled: false,
    luncheon_vouchers: false,
    needs_cooking: false,
    age_limit: false,
}

export const product6: Product = {
    id: 6,
    name: 'Salade de quinoa aux légumes grillés',
    client: managers.manager8,
    supplier: suppliers.supplier15,
    category: categories.category24,
    price: 7.5,
    is_price_weight: false,
    allergens: [allergens.allergen1],
    purchase_price: 2.5,
    valid_number_of_days: 25,
    tva: 5.5,
    description:
        'Délicieuse salade de quinoa avec courgettes, poivrons et carottes grillées, assaisonnée d’une vinaigrette au citron.',
    ean: '3760198780115',
    client_serial: 'LDZ9214SQG',
    photo: 'https://www.lacuisinedebernard.com/wp-content/uploads/2023/05/salade-quinoa-legumes.jpg',
    weight: 200,
    disabled: false,
    luncheon_vouchers: true,
    needs_cooking: false,
    age_limit: false,
}

export const product7: Product = {
    id: 7,
    name: 'Pavé de saumon sauce teriyaki',
    client: managers.manager14,
    supplier: suppliers.supplier27,
    category: categories.category7,
    price: 12,
    is_price_weight: false,
    allergens: [allergens.allergen1, allergens.allergen2],
    purchase_price: 5.5,
    valid_number_of_days: 20,
    tva: 10,
    description:
        'Pavé de saumon mariné dans une sauce teriyaki maison, accompagné de riz basmati et légumes croquants.',
    ean: '3760198780126',
    client_serial: 'LDZ6732PST',
    photo: 'https://www.ptitchef.com/imgupl/recipe/pave-de-saumon-marine-teriyaki--550353p695750.jpg',
    weight: 250,
    disabled: true,
    luncheon_vouchers: true,
    needs_cooking: true,
    cooking_temp: 100,
    cooking_time: 2,
    age_limit: false,
}

export const product8: Product = {
    id: 8,
    name: 'Tarte aux fraises et crème pâtissière',
    client: managers.manager1,
    supplier: suppliers.supplier13,
    category: categories.category1,
    price: 4.5,
    is_price_weight: false,
    allergens: [allergens.allergen1, allergens.allergen2, allergens.allergen3],
    purchase_price: 1.8,
    valid_number_of_days: 5,
    tva: 5.5,
    description:
        'Délicieuse tarte garnie d’une crème pâtissière onctueuse et de fraises fraîches sur une pâte sablée maison.',
    ean: '3760198780137',
    client_serial: 'LDZ8234TAF',
    photo: 'https://img.cuisineaz.com/660x660/2023/03/23/i195014-tarte-aux-fraises-creme-patissiere.webp',
    weight: 200,
    disabled: false,
    luncheon_vouchers: false,
    needs_cooking: false,
    age_limit: false,
}

export const product9: Product = {
    id: 9,
    name: 'Pizza Margherita',
    client: managers.manager1,
    supplier: suppliers.supplier12,
    category: categories.category27,
    price: 8.5,
    is_price_weight: false,
    allergens: [],
    purchase_price: 3.2,
    valid_number_of_days: 10,
    tva: 10,
    description:
        'Pizza italienne traditionnelle à base de sauce tomate, mozzarella fondante et basilic frais.',
    ean: '3760198780148',
    client_serial: 'LDZ6723PZM',
    photo: 'https://www.academiedugout.fr/images/64362/960-auto/fotolia_109246998_subscription_xxl-copy.jpg',
    weight: 450,
    disabled: false,
    luncheon_vouchers: true,
    needs_cooking: true,
    cooking_time: 3,
    cooking_temp: 100,
    age_limit: false,
}

export const product10: Product = {
    id: 10,
    name: 'Poulet rôti aux herbes de Provence',
    client: managers.manager1,
    supplier: suppliers.supplier12,
    category: categories.category25,
    price: 14,
    is_price_weight: true,
    allergens: [],
    purchase_price: 6.8,
    valid_number_of_days: 3,
    tva: 10,
    description:
        'Poulet fermier rôti lentement avec un mélange d’herbes de Provence, accompagné de pommes de terre rôties.',
    ean: '3760198780159',
    client_serial: 'LDZ1234PRH',
    photo: 'https://www.iletaitunefoislapatisserie.com/wp-content/uploads/2021/03/poulet-roti-recette.jpg',
    weight: 900,
    disabled: false,
    luncheon_vouchers: true,
    needs_cooking: true,
    cooking_time: 4,
    cooking_temp: 100,
    age_limit: false,
}

export const product11: Product = {
    id: 11,
    name: 'Fromage de chèvre affiné',
    client: managers.manager3,
    supplier: suppliers.supplier26,
    category: categories.category8,
    price: 5.2,
    is_price_weight: true,
    allergens: [],
    purchase_price: 2.1,
    valid_number_of_days: 60,
    tva: 5.5,
    description:
        'Fromage de chèvre affiné artisanal au goût délicatement prononcé, idéal sur du pain ou en salade.',
    ean: '3760198780160',
    client_serial: 'LDZ9842FCA',
    photo: 'https://www.lesfruitsdelaterre.fr/wp-content/uploads/2020/06/fromage-de-chevre-affine.jpeg',
    weight: 180,
    disabled: true,
    luncheon_vouchers: false,
    needs_cooking: false,
    age_limit: false,
}

export const product12: Product = {
    id: 12,
    name: 'Jus d’orange pressé 100% pur jus',
    client: managers.manager4,
    supplier: suppliers.supplier6,
    category: categories.category13,
    price: 3.5,
    is_price_weight: false,
    allergens: [],
    purchase_price: 1.5,
    valid_number_of_days: 7,
    tva: 5.5,
    description:
        'Jus d’orange frais pressé sans conservateurs ni additifs, riche en vitamine C.',
    ean: '3760198780171',
    client_serial: 'LDZ5432JOP',
    photo: 'https://assets.afcdn.com/recipe/20170607/67810_w1024h1024c1cx1152cy1728cxt0cyt0cxb2304cyb3456.jpg',
    weight: 500,
    disabled: false,
    luncheon_vouchers: false,
    needs_cooking: false,
    age_limit: false,
}

export const product13: Product = {
    id: 13,
    name: 'Lasagnes à la bolognaise',
    client: managers.manager4,
    supplier: suppliers.supplier6,
    category: categories.category14,
    price: 9.5,
    is_price_weight: true,
    allergens: [],
    purchase_price: 4.2,
    valid_number_of_days: 7,
    tva: 10,
    description:
        'Lasagnes maison avec une sauce bolognaise mijotée, béchamel onctueuse et fromage gratiné.',
    ean: '3760198780182',
    client_serial: 'LDZ1243LB',
    photo: 'https://www.ptitchef.com/imgupl/recipe/lasagnes-a-la-bolognaise--379235p695750.jpg',
    weight: 400,
    disabled: false,
    luncheon_vouchers: true,
    needs_cooking: true,
    cooking_time: 2,
    cooking_temp: 100,
    age_limit: false,
}

export const product14: Product = {
    id: 14,
    name: 'Burger végétarien aux pois chiches',
    client: managers.manager4,
    supplier: suppliers.supplier7,
    category: categories.category14,
    price: 7.8,
    is_price_weight: false,
    allergens: [],
    purchase_price: 3.5,
    valid_number_of_days: 5,
    tva: 10,
    description:
        'Burger végétarien composé d’un steak de pois chiches et légumes grillés, accompagné d’une sauce légère.',
    ean: '3760198780193',
    client_serial: 'LDZ6754BVP',
    photo: 'https://img.cuisineaz.com/660x660/2022/11/23/i190555-burger-vegetarien.jpg',
    weight: 300,
    disabled: false,
    luncheon_vouchers: true,
    needs_cooking: true,
    cooking_time: 2,
    cooking_temp: 100,
    age_limit: false,
}

export const product15: Product = {
    id: 15,
    name: 'Mille-feuille à la vanille',
    client: managers.manager4,
    supplier: suppliers.supplier10,
    category: categories.category15,
    price: 4.2,
    is_price_weight: false,
    allergens: [],
    purchase_price: 1.8,
    valid_number_of_days: 3,
    tva: 5.5,
    description:
        'Feuilletage croustillant garni d’une crème pâtissière vanillée et d’un glaçage au sucre.',
    ean: '3760198780204',
    client_serial: 'LDZ9273MFV',
    photo: 'https://assets.afcdn.com/recipe/20210615/119829_w1024h1024c1cx2160cy1440cxt0cyt0cxb4320cyb2880.jpg',
    weight: 150,
    disabled: false,
    luncheon_vouchers: false,
    needs_cooking: false,
    age_limit: false,
}

export const product16: Product = {
    id: 16,
    name: 'Sushis saumon et avocat',
    client: managers.manager5,
    supplier: suppliers.supplier30,
    category: categories.category10,
    price: 14.5,
    is_price_weight: false,
    allergens: [],
    purchase_price: 6.2,
    valid_number_of_days: 3,
    tva: 10,
    description:
        'Assortiment de sushis au saumon frais et avocat, accompagnés de sauce soja et gingembre.',
    ean: '3760198780215',
    client_serial: 'LDZ8321SSA',
    photo: 'https://www.ptitchef.com/imgupl/recipe/sushis-au-saumon--501827p695750.jpg',
    weight: 300,
    disabled: false,
    luncheon_vouchers: true,
    needs_cooking: false,
    age_limit: false,
}

export const product17: Product = {
    id: 17,
    name: 'Fromage blanc et coulis de fruits rouges',
    client: managers.manager5,
    supplier: suppliers.supplier17,
    category: categories.category5,
    price: 3.8,
    allergens: [],
    is_price_weight: false,
    purchase_price: 1.5,
    valid_number_of_days: 7,
    tva: 5.5,
    description:
        'Fromage blanc onctueux accompagné d’un coulis de fruits rouges maison.',
    ean: '3760198780226',
    client_serial: 'LDZ1239FBC',
    photo: 'https://assets.afcdn.com/recipe/20200604/110914_w1024h1024c1cx3120cy2080cxt0cyt0cxb6240cyb4160.jpg',
    weight: 200,
    disabled: true,
    luncheon_vouchers: false,
    needs_cooking: false,
    age_limit: false,
}

export const product18: Product = {
    id: 18,
    name: 'Côte de bœuf grillée',
    client: managers.manager5,
    supplier: suppliers.supplier11,
    category: categories.category4,
    price: 22.5,
    is_price_weight: true,
    allergens: [],
    purchase_price: 10.5,
    valid_number_of_days: 5,
    tva: 10,
    description:
        'Côte de bœuf grillée à la perfection, servie avec une sauce béarnaise maison.',
    ean: '3760198780237',
    client_serial: 'LDZ8457CBG',
    photo: 'https://www.ptitchef.com/imgupl/recipe/cote-de-boeuf-grillee--563625p695750.jpg',
    weight: 600,
    disabled: false,
    luncheon_vouchers: true,
    needs_cooking: true,
    cooking_time: 3,
    cooking_temp: 100,
    age_limit: false,
}

export const product19: Product = {
    id: 19,
    name: 'Raviolis ricotta épinards',
    client: managers.manager5,
    supplier: suppliers.supplier11,
    category: categories.category22,
    price: 6.5,
    is_price_weight: false,
    allergens: [allergens.allergen3],
    purchase_price: 2.8,
    valid_number_of_days: 8,
    tva: 10,
    description:
        'Délicieux raviolis fourrés à la ricotta et aux épinards, servis avec une sauce tomate basilic.',
    ean: '3760198780248',
    client_serial: 'LDZ6421RRE',
    photo: 'https://img.cuisineaz.com/660x660/2023/05/12/i194474-raviolis-ricotta-epinards.jpg',
    weight: 250,
    disabled: false,
    luncheon_vouchers: true,
    needs_cooking: true,
    cooking_time: 2,
    cooking_temp: 100,
    age_limit: false,
}

export const product20: Product = {
    id: 20,
    name: 'Tartare de thon aux agrumes',
    client: managers.manager1,
    supplier: suppliers.supplier13,
    category: categories.category27,
    price: 13.5,
    is_price_weight: true,
    allergens: [allergens.allergen4],
    purchase_price: 5.9,
    valid_number_of_days: 3,
    tva: 10,
    description:
        'Tartare de thon frais assaisonné d’un mélange d’agrumes et d’épices, accompagné de toasts croustillants.',
    ean: '3760198780259',
    client_serial: 'LDZ7854TTA',
    photo: 'https://img.cuisineaz.com/660x660/2022/11/24/i190574-tartare-de-thon-aux-agrumes.jpg',
    weight: 200,
    disabled: false,
    luncheon_vouchers: true,
    needs_cooking: false,
    age_limit: false,
}

export const product21: Product = {
    id: 21,
    name: 'Pain aux céréales',
    client: managers.manager4,
    supplier: suppliers.supplier10,
    category: categories.category16,
    price: 3.2,
    is_price_weight: false,
    allergens: [],
    purchase_price: 1.2,
    valid_number_of_days: 5,
    tva: 5.5,
    description:
        'Pain artisanal aux céréales, riche en fibres et parfait pour accompagner vos repas.',
    ean: '3760198780260',
    client_serial: 'LDZ3642PAC',
    photo: 'https://img.cuisineaz.com/660x660/2023/01/06/i193749-pain-aux-cereales.jpg',
    weight: 500,
    disabled: false,
    luncheon_vouchers: false,
    needs_cooking: false,
    age_limit: false,
}

export const product22: Product = {
    id: 22,
    name: 'Salade césar au poulet',
    client: managers.manager4,
    supplier: suppliers.supplier6,
    category: categories.category14,
    price: 9.8,
    is_price_weight: false,
    allergens: [],
    purchase_price: 4.5,
    valid_number_of_days: 3,
    tva: 10,
    description:
        'Salade césar composée de laitue croquante, poulet grillé, copeaux de parmesan et croûtons maison, avec une sauce césar.',
    ean: '3760198780271',
    client_serial: 'LDZ9854SCP',
    photo: 'https://www.ptitchef.com/imgupl/recipe/salade-cesar-au-poulet--465827p695750.jpg',
    weight: 300,
    disabled: false,
    luncheon_vouchers: true,
    needs_cooking: false,
    age_limit: false,
}

export const product23: Product = {
    id: 23,
    name: 'Gaufres liégeoises',
    client: managers.manager2,
    supplier: suppliers.supplier4,
    category: categories.category19,
    price: 3.8,
    is_price_weight: false,
    allergens: [],
    purchase_price: 1.5,
    valid_number_of_days: 7,
    tva: 5.5,
    description:
        'Gaufres belges moelleuses et caramélisées, idéales pour une pause gourmande.',
    ean: '3760198780282',
    client_serial: 'LDZ7523GL',
    photo: 'https://www.ptitchef.com/imgupl/recipe/gaufres-liegeoises--523457p695750.jpg',
    weight: 180,
    disabled: false,
    luncheon_vouchers: false,
    needs_cooking: false,
    age_limit: false,
}

export const product24: Product = {
    id: 24,
    name: 'Smoothie mangue ananas',
    client: managers.manager2,
    supplier: suppliers.supplier8,
    category: categories.category17,
    price: 4.2,
    is_price_weight: false,
    allergens: [],
    purchase_price: 1.8,
    valid_number_of_days: 5,
    tva: 5.5,
    description:
        'Smoothie exotique à la mangue et à l’ananas, sans sucre ajouté et riche en vitamines.',
    ean: '3760198780293',
    client_serial: 'LDZ9634SMA',
    photo: 'https://img.cuisineaz.com/660x660/2023/05/24/i194476-smoothie-mangue-ananas.jpg',
    weight: 300,
    disabled: false,
    luncheon_vouchers: false,
    needs_cooking: false,
    age_limit: false,
}

export const product25: Product = {
    id: 25,
    name: 'Bœuf bourguignon',
    client: managers.manager2,
    supplier: suppliers.supplier9,
    category: categories.category20,
    price: 14.5,
    is_price_weight: true,
    allergens: [allergens.allergen1],
    purchase_price: 6.5,
    valid_number_of_days: 6,
    tva: 10,
    description:
        'Plat mijoté traditionnel à base de bœuf tendre, carottes, oignons et vin rouge.',
    ean: '3760198780304',
    client_serial: 'LDZ8423BB',
    photo: 'https://www.ptitchef.com/imgupl/recipe/boeuf-bourguignon--450327p695750.jpg',
    weight: 400,
    disabled: true,
    luncheon_vouchers: true,
    needs_cooking: true,
    cooking_time: 4,
    cooking_temp: 100,
    age_limit: false,
}

export const product26: Product = {
    id: 26,
    name: 'Couscous royal',
    client: managers.manager2,
    supplier: suppliers.supplier5,
    category: categories.category21,
    price: 13.8,
    is_price_weight: true,
    allergens: [],
    purchase_price: 5.9,
    valid_number_of_days: 6,
    tva: 10,
    description:
        'Couscous royal aux légumes, merguez, poulet et agneau, accompagné de semoule fine et bouillon épicé.',
    ean: '3760198780315',
    client_serial: 'LDZ7532CR',
    photo: 'https://www.ptitchef.com/imgupl/recipe/couscous-royal--387152p695750.jpg',
    weight: 600,
    disabled: true,
    luncheon_vouchers: true,
    needs_cooking: true,
    cooking_time: 3,
    cooking_temp: 100,
    age_limit: false,
}

export const product27: Product = {
    id: 27,
    name: 'Yogourt aux fruits rouges',
    client: managers.manager2,
    supplier: suppliers.supplier8,
    category: categories.category18,
    price: 2.8,
    is_price_weight: false,
    allergens: [],
    purchase_price: 1.2,
    valid_number_of_days: 12,
    tva: 5.5,
    description:
        'Yaourt onctueux aux fruits rouges avec des morceaux de fraises et framboises.',
    ean: '3760198780326',
    client_serial: 'LDZ8623YFR',
    photo: 'https://assets.afcdn.com/recipe/20200519/111200_w1024h1024c1cx3120cy2080cxt0cyt0cxb6240cyb4160.jpg',
    weight: 125,
    disabled: false,
    luncheon_vouchers: false,
    needs_cooking: false,
    age_limit: false,
}

export const product28: Product = {
    id: 28,
    name: 'Crêpes au caramel beurre salé',
    client: managers.manager1,
    supplier: suppliers.supplier14,
    category: categories.category1,
    price: 5.2,
    is_price_weight: false,
    allergens: [],
    purchase_price: 2.3,
    valid_number_of_days: 5,
    tva: 5.5,
    description: 'Crêpes moelleuses garnies de caramel au beurre salé maison.',
    ean: '3760198780337',
    client_serial: 'LDZ6425CCB',
    photo: 'https://img.cuisineaz.com/660x660/2023/05/22/i194477-crepes-au-caramel.jpg',
    weight: 250,
    disabled: false,
    luncheon_vouchers: false,
    needs_cooking: false,
    age_limit: false,
}
